// @ts-check
import { POWER } from './tuning.js';
import { playerBody } from './power.js';
import { querySolids } from './geometry.js';
import { strikeEnemy } from './enemies.js';
import { pulseBoss } from './bosses.js';
/** @param {import('./types.js').Level} level @param {import('./player.js').Position} state @param {import('./types.js').EventSink} [emit] */
export function firePulse(level, state, emit) {
  if (state.power !== 'pulse' || state.shotCooldown || level.shots.length >= POWER.maxShots || level.status !== 'playing') return false;
  const body = playerBody(state);
  level.shots.push({ x: state.x + body.width / 2 - 4, y: state.y + body.height * 0.48, width: 8, height: 5, vx: state.facing * POWER.shotSpeed, age: 0 });
  state.shotCooldown = POWER.shotCooldown; level.started = true;
  emit?.({ type: 'pulse-fired', x: state.x, y: state.y });
  return true;
}
/** @param {import('./types.js').Level} level @param {number} dt @param {import('./types.js').EventSink} [emit] */
export function updateShots(level, dt, emit) {
  level.shots = level.shots.filter((shot) => {
    const previousX = shot.x; shot.x += shot.vx * dt; shot.age += dt;
    const left = Math.min(previousX, shot.x), right = Math.max(previousX, shot.x) + shot.width;
    const intersects = (/** @type {import('./types.js').Rect} */ body) => right > body.x && left < body.x + body.width && shot.y + shot.height > body.y && shot.y < body.y + body.height;
    // Stop at the nearest obstruction, so a pulse cannot hit through a wall.
    const contacts = [...querySolids(level, left, right), ...level.enemies.filter((enemy) => enemy.mode !== 'dead'), ...(level.boss && level.boss.phase !== 'defeated' ? [level.boss] : [])].filter(intersects)
      .sort((a, b) => shot.vx > 0 ? a.x - b.x : b.x + b.width - a.x - a.width);
    const hit = contacts[0];
    if (hit) {
      if ('mode' in hit) strikeEnemy(hit, emit, true);
      if ('definition' in hit) pulseBoss(hit, emit);
      emit?.({ type: 'pulse-impact', x: shot.x, y: shot.y });
      return false;
    }
    return shot.age < POWER.shotLifetime && shot.x + shot.width > 0 && shot.x < level.width;
  });
}
